// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".project-cherry-pick-form .project-cherry-pick-form__body-branch{display:flex;flex-direction:column}.project-cherry-pick-form .project-cherry-pick-form__body-branch code{margin-top:2px}.project-cherry-pick-form .project-cherry-pick-form__footer{padding-top:8px;display:flex;justify-content:flex-end;border-top:1px solid var(--border-color)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
